// Actions
/**
 * Authorize a code returned from Github
 */
export function authorizeCode(code){
  return {
    type: 'AUTHORIZE_CODE',
    code,
  }
}

/**
 * Handle an error when authorizing on Github
 * @param {Error} error Has the properties message, code and uri.
 */
/*export function authorizeError(error){
  return {
    type: 'AUTHORIZE_ERROR',
    error,
  }
}*/

/**
 * Successfully authorize with an access token
 * @param {string} token
 */
export function authorizeToken(token){
  return {
    type: 'AUTHORIZE_TOKEN',
    token,
  }
}

/**
 * Log the user out
 * @returns {object}
 */
export function logout(){
  return {
    type: 'LOGOUT'
  }
}


// WEBPACK FOOTER //
// ./src/store/token/actions.js